import React, { Component } from "react"
import { Col, Row } from "elemental"
import { browserHistory, Link } from "react-router"
import _ from "lodash"
import Responsive from "react-responsive"
import { translate } from "translate"

import NavigationSidebar from "../components/Navigation/NavigationSidebar"
import Filter from "../components/Filter/Filter"
// import ProductList from "../components/Product/ProductList"
// import ProductCol from "../components/Product/ProductCol"
import ProductColDetail from "../components/Product/ProductColDetail"
import "./CollectionPage.scss"

import shop from "../shop/shop"

export default class CollectionPage extends Component {
  constructor( props ) {
    super( props )
    this.state = {
      products: [],
      loaded:   false,
      filter:   {
        total:       12,
        pageSize:    shop.settings.get( "pageSize" ),
        currentPage: 1,
      },
      query:    {
        page:  props.location.page || 1,
        count: props.location.count || shop.settings.get( "pageSize" ),
        total: 48,
        limit: 3
      }
    }
  }

  componentDidMount() {
    this.loadFrom( this.props )
  }

  componentWillReceiveProps( props ) {
    if ( this.current_id !== props.params.id ) {
      this.loadFrom( props )
    }
  }

  loadFrom( props ) {
    let id = props.params.id || props.params.parent
    let { query } = props.location
    query.count = query.count || this.state.query.count
    query.page = query.page || 1
    this.load( id, query )
  }

  load( id, query ) {
    query.sort = query.sort || "stock" // DEFAULT QUERY SORT
    this.current_id = id
    let category = _.first( _.filter( [...shop.categoriesById.entries()], (( [cat_id, cat] ) => cat.map_id === id) ) ) // eslint-disable-line
    if ( category ) category = category[ 1 ]

    // collection === all => load data from all categories
    if ( id === "all" ) {
      return shop.products.search( "%%", query )
        .then( res => {
          this.receive( res, category, query )
        } )
    }

    if ( id === "023000000" /*ALL AROUND */ ) {
      return shop.products.fromCategory( [
        "008000000", // Beard Head
        "012000000",// , Gamago
        "011000000",// , Hikali
        "010000000",// , Hoobbe
        "026000000",// , Nanoku
        "015000000",// , Seishinsev
        "009000000",// , Slam
        "027000000",// , The Source
        "020000000",// , Tobar
        "025000000",// Treat Factory
        "035000000",// Chasing Threads
        "018000000",// NPW
        "028000000",// iThinking
        "023000000",
      ], query )
        .then( res => this.receive( res, category, query ) )
    }

    // console.timeEnd( "bench::categories" )
    shop.products.fromCategory( id, query )
      .then( res => {
        let { products } = res
        if ( products.length === 0 ) {
          return shop.products.fromCategory( category.children.map( category => category.map_id ), query )
            .then( res => this.receive( res, category, query ) )
        }
        this.receive( res, category, query )
      } )
  }

  receive( res, category, query ) {
    this.setState( {
      category,
      size:     res.size,
      products: res.products,
      query,
    } )
  }

  onChangeFilter = ( filter ) => {
    this.updateQuery( filter )
  }

  updateQuery( { page, sort, pageSize, brand, dir } ) {
    // console.log(`change`, {
    //    page,
    //    sort,
    //    pageSize,
    //    brand
    // })

    let id = this.props.params.id || this.props.params.parent
    let query = this.props.location.query
    query.page = page || query.page
    query.count = pageSize || query.count
    query.sort = sort || query.sort || "stock"
    query.brand = brand || query.brand
    query.dir = dir || query.dir

    console.log( "new direction", { dir } )

    let pathname = `/collection/${id}`
    if ( this.props.params.parent ) {
      pathname = `/collection/${this.props.params.parent}/${id}`
    }

    browserHistory.push( {
      pathname,
      query
    } )
    this.load( id, query )
  }

  render() {

    let products = this.state.products.map( ( product, key ) => {
      return <ProductColDetail key={key}
                               product={product}> </ProductColDetail>
    } )
    let { size, category } = this.state

    const invalid = category && category.invalid
    if ( invalid ) {
      return <div className="tc pt4">
        <p>{translate( "brand_not_avail" )}</p>
      </div>
    }

    let categoryTitle = ""
    if ( category && category.desc ) categoryTitle = category.desc.short_des

    let filter = {
      currentPage: Number( this.state.query.page ),
      total:       Number( this.state.size ) || 6,
      pageSize:    Number( this.state.query.count ),
      brand:       String( this.state.query.brand ),
      sort:        String( this.state.query.sort )
    }

    let path = shop.getCategoryPath( this.current_id )

    return (
      <div className="container">
        <Row className="pt4">
          <Responsive minWidth={992}>
            <Col lg="1/5">
              {path.length > 1 ?
                <Link style={{ whiteSpace: "nowrap" }} to={path[ 0 ].link} className="parent-title">{path[ 0 ].title}</Link> : null}
              {path.length === 1 ? <Link to="/home" className="parent-title">&nbsp;</Link> : null}
              <div className="collection-header">
                <div className="f3 b" style={{ whiteSpace: "nowrap" }}>{categoryTitle}</div>
                <div>{size} Artikel</div>
              </div>
              <NavigationSidebar> </NavigationSidebar>
            </Col>
          </Responsive>
          <Col xs="1" sm="1" md="1" lg="4/5">
            {/*Filter*/}
            <section style={{ marginBottom: "0" }}>
              <Filter onChange={this.onChangeFilter} pagination={false} {...filter} />
            </section>
            {/*Products from Category*/}

            <section className="identifier">
              <Row>
                {products}
              </Row>
            </section>

            {/*Filter*/}
            <section>
              <Filter showFilter={true}
                      onChange={this.onChangeFilter} {...filter} />
            </section>
          </Col>
        </Row>
        {/*<Row>*/}
        {/*<Col sm="1">*/}
        {/*/!*Topseller*!/*/}
        {/*<section>*/}
        {/*<ProductList*/}
        {/*title="Topseller"*/}
        {/*sm="1/5"*/}
        {/*list={ids}*/}
        {/*repeat={ProductCol}> </ProductList>*/}
        {/*</section>*/}
        {/*</Col>*/}
        {/*</Row>*/}
      </div>
    )
  }
}

CollectionPage.propTypes = {
  params:   React.PropTypes.object,
  filter:   React.PropTypes.object,
  location: React.PropTypes.object
}

// function toPathCatgory(path, cat_id) {
//   let category = shop.categoriesById.get(cat_id)
//   if (cat_id && category) {
//     path.push({
//       title: category.desc.short_des,
//       link:  "/collection/" + cat_id
//     })
//   }
// }



// WEBPACK FOOTER //
// ./src/pages/CollectionPage.js